export const SRT_LANGUAGES = {
  de: "German",
  es: "Spanish",
  "es-xl": "Spanish - Latin America",
  fr: "French",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  pl: "Polish",
  "pt-br": "Portuguese - Brazil",
  "zh-cn": "Chinese - Simplified",
  "zh-tw": "Chinese - Traditional",
  vi: "Vietnamese",
  en: "English",
}
